import { Module } from 'vuex'

import { CommentaryPageStateModuleName } from '../modules'

import { GetCommentaryUseCase } from '@/application/commentary/getCommentaryUseCase'
import { CommentaryRepository } from '@/domain/repositories/commentary/CommentaryRepository'

interface GetCommentaryState {
  isLoading: boolean
  error: Error | null
}

export const getCommentaryModule = (commentaryRepository: CommentaryRepository): Module<GetCommentaryState, any> => {
  const getCommentaryUseCase = new GetCommentaryUseCase(commentaryRepository)

  return {
    namespaced: true,
    state: {
      isLoading: false,
      error: null
    },
    mutations: {
      setIsLoading(state, isLoading: boolean) {
        state.isLoading = isLoading
      },
      setError(state, error: Error | null) {
        state.error = error
      }
    },
    actions: {
      async getCommentary(
        { state, commit, rootGetters },
        {
          displayLanguage,
          problemId,
          pattern,
          type,
          filter
        }: { displayLanguage: string; problemId: string; pattern: string; type: string; filter: string }
      ): Promise<string> {
        const commentaryList =
          pattern == 'pre'
            ? rootGetters[`${CommentaryPageStateModuleName}/preCommentaryList`]
            : rootGetters[`${CommentaryPageStateModuleName}/postCommentaryList`]
        if (commentaryList && commentaryList[type] && commentaryList[type][filter]) {
          return commentaryList[type][filter] as string
        }

        commit('setIsLoading', true)
        commit('setError', null)

        try {
          const res = await getCommentaryUseCase.getCommentary(displayLanguage, problemId, pattern, type, filter)

          if (pattern === 'pre') {
            await commit(
              `${CommentaryPageStateModuleName}/setPreCommentary`,
              { type: type, filter: filter, commentary: res.html },
              { root: true }
            )
          } else if (pattern === 'post') {
            await commit(
              `${CommentaryPageStateModuleName}/setPostCommentary`,
              { type: type, filter: filter, commentary: res.html },
              { root: true }
            )
          }
          return res.html
        } catch (error) {
          commit('setError', error)
        } finally {
          commit('setIsLoading', false)
        }
        return ''
      }
    },
    getters: {
      isLoading: state => state.isLoading,
      error: state => state.error
    }
  }
}
